import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";

import { AdminConversationDetail } from "./components/AdminConversationDetail";
import { AdminConversationList } from "./components/AdminConversationList";

/**
 * Support-review surface over saved help conversations (GLOBAL_ADMIN @ company 1, see
 * Private.tsx): the list of transcripts and one read-only transcript with its ratings.
 *
 * Articles are no longer edited here — help content is authored and published in Signalist Brain,
 * and the assistant answers from the published help center rather than from anything this app
 * stores. What stays is the record of what users asked and how the answers landed.
 */
export const HelpCenterAdmin: FunctionComponent = () => (
	<Routes>
		<Route element={<AdminConversationList />} path="/" />
		<Route element={<AdminConversationDetail />} path="/:conversationId" />
	</Routes>
);
